/**
 * notificationService — lightweight wrapper around vue-toastification.
 *
 * Use these helpers everywhere instead of calling this.$toast directly
 * so the notification runtime can be swapped in one place.
 *
 * Usage:
 *   import { notifySuccess, notifyError, notifyInfo } from '@/utils/notificationService';
 *   notifySuccess('Reply saved');
 *   notifyError(this.$t('message.requestFailed'));
 */
import Vue from "vue";

function toast() {
  return Vue.prototype.$toast;
}

export function notifySuccess(message, options = {}) {
  return toast().success(message, {
    toastClassName: "custom-success-toast",
    timeout: 3000,
    ...options,
  });
}

export function notifyError(message, options = {}) {
  return toast().error(message, {
    toastClassName: "custom-error-toast",
    timeout: 3000,
    ...options,
  });
}

export function notifyInfo(message, options = {}) {
  return toast().info(message, {
    toastClassName: "custom-info-toast",
    timeout: 3000,
    ...options,
  });
}

export function notifyWarning(message, options = {}) {
  return toast().warning(message, {
    toastClassName: "custom-warning-toast",
    timeout: 3000,
    ...options,
  });
}

export function notifyClear() {
  return toast().clear();
}
